// extracted by mini-css-extract-plugin
export default {"chartContainer":"styles_chartContainer__J4afj","pieTitle":"styles_pieTitle__GLWcm"};